const redirectToCVActivation = () => {
    const token = window.sessionStorage.getItem('token');
    document.cookie = "portal={#token#:#".concat(token).concat("#};path=/;domain=.coopeuch.cl");

    window.open(process.env.REACT_APP_API_POLL_URL_BASE, '_parent');
}
    

export default redirectToCVActivation;
